<template>
  <div>
    <div @click="routeUser" class="float-left">
      <span v-if="!myOwn" class="pointer hover">
        <Avatar
          v-if="avatar != null"
          class="timeline-avatar-navigation"
          :src="`https://tradeinpool.com/upload/${avatar}.png`"
          :size="40"
        ></Avatar>
        <Avatar v-else class="timeline-avatar-navigation" :username="username" :size="40"></Avatar>
      </span>
    </div>
    <div @click="routeLevel0" class="float-left pt-2">
      <span v-if="!myOwn" class="pointer subheadline ml-3">{{username}}'s {{type}}</span>
      <span v-else class="pointer subheadline">My {{type}}</span>
    </div>
    <div @click="routeLevel1" v-if="level1" class="float-left pt-1">
      <v-icon color="rgba(128, 143, 156, 1)">keyboard_arrow_right</v-icon>
      <v-chip class color="rgba(128, 143, 156, 0.2)" label outlined>
        <span class="date-font text-grey mr-1">Detail of</span>
        <span class="date-font text-green">{{level1}}</span>
      </v-chip>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
export default {
  name: "Navigation",
  components: {
    Avatar
  },
  props: {
    type: String,
    myOwn: Boolean,
    username: String,
    avatar: String,
    level1: String
  },
  methods: {
    routeUser() {
      return this.$router.push({
        name: "user",
        params: { name: this.username }
      });
    },
    routeLevel0() {
      return this.$router.push({
        name: this.type,
        params: { name: this.username }
      });
    },
    routeLevel1() {
      return this.$router.push({
        name: this.type,
        params: { name: this.username }
      });
    }
  }
};
</script>

<style>
</style>